"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuth = void 0;
require("reflect-metadata");
const router_1 = __importDefault(require("next/router"));
const react_1 = require("react");
const logout = (csrf) => () => __awaiter(void 0, void 0, void 0, function* () {
    const result = yield fetch('/logout', {
        method: 'POST',
        credentials: 'include',
        mode: 'same-origin',
        headers: [['Content-Type', 'application/json']],
        body: JSON.stringify({
            _csrf: csrf.current,
        }),
    });
    if (result.ok) {
        yield router_1.default.push('/login');
    }
    else {
        window.location.reload();
    }
});
const useAuth = (serverProps) => {
    var _a, _b;
    const props = serverProps || {};
    const csrfToken = (0, react_1.useRef)(null);
    const auth = props.auth;
    let tokenUpdated = false;
    if ((auth === null || auth === void 0 ? void 0 : auth.csrfToken) && (auth === null || auth === void 0 ? void 0 : auth.csrfToken) !== csrfToken.current) {
        csrfToken.current = auth.csrfToken;
        tokenUpdated = true;
    }
    const context = {
        props,
    };
    // Cache/restore auth state from localstorage
    if (global.localStorage && !((_b = (_a = context === null || context === void 0 ? void 0 : context.props) === null || _a === void 0 ? void 0 : _a.auth) === null || _b === void 0 ? void 0 : _b.isSsr)) {
        if (!context.props.auth || !csrfToken.current) {
            const cachedAuth = ((global.localStorage.getItem('auth')
                ? JSON.parse(global.localStorage.getItem('auth')) || null
                : null));
            if (cachedAuth) {
                cachedAuth.fromLocalStorage = true;
                if (!csrfToken.current) {
                    csrfToken.current = cachedAuth.csrfToken;
                }
                cachedAuth.csrfToken = csrfToken.current;
            }
            if (!context.props.auth) {
                context.props.auth = cachedAuth || {
                    userId: null,
                    isAuthorized: false,
                    csrfToken: csrfToken.current,
                    isSsr: false,
                    hasAccess: false,
                };
            }
            else if (cachedAuth) {
                context.props.auth.fromLocalStorage = true;
            }
        }
        if (tokenUpdated) {
            global.localStorage.setItem('auth', JSON.stringify(context.props.auth));
        }
    }
    return !context.props.auth
        ? {
            userId: null,
            isAuthorized: false,
            hasAccess: false,
            csrfToken: csrfToken.current,
            _csrf: csrfToken.current,
            fromLocalStorage: false,
            logout: logout(csrfToken),
            isSsr: false,
        }
        : Object.assign(Object.assign({}, context.props.auth), { csrfToken: csrfToken.current, _csrf: csrfToken.current, logout: logout(csrfToken) });
};
exports.useAuth = useAuth;
//# sourceMappingURL=auth.js.map